import React, { useState, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Table } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import GetAmotMedaCat from "./GetAmotMedaCat";
import DeleteConfirmation from "../../shared/DeleteConfirmation";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  mekhraz_id,
  amotMedaCat,
  amotMeda,
}) => {
  const [amaId, setAmaId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const total = amotMeda.reduce((sum, item) => {
    return sum + item.meshkal * (item.tsion / 100);
  }, 0);
  const handleEditClick = (event, pirsom) => {
    event.preventDefault();
    setAmaId(pirsom.id);
  };

  const handleCancelClick = () => {
    setAmaId(null);
  };

  if (!amotMeda) return null;
  return (
    <>
      <div>
        <Row>
          <Col sm="10" md={{ size: 3, offset: 1 }}>
            <form onSubmit={increment}>
              <label style={{ color: "red", fontWeight: "bold" }}>
                {" "}
                ציון הסף: {total.toFixed(2)}
              </label>
              <Table hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>קטגוריה</th>
                    <th>משקל ממאה נקודות</th>
                    <th>ציון</th>
                    <th>פעולות</th>
                  </tr>
                </thead>
                <tbody>
                  {amotMeda?.map((ama) => (
                    <Fragment key={ama.id}>
                      {amaId === ama.id ? (
                        <Edit
                          ama={ama}
                          handleCancelClick={handleCancelClick}
                          increment={increment}
                          counter={counter}
                          setAmaId={setAmaId}
                          amotMedaCat={amotMedaCat}
                          amotMeda={amotMeda}
                        />
                      ) : (
                        <ReadOnlyRows
                          ama={ama}
                          handleEditClick={handleEditClick}
                          increment={increment}
                          setAmaId={setAmaId}
                          amotMedaCat={amotMedaCat}
                          setShowError={setShowError}
                          setErrorMessage={setErrorMessage}
                          setErrorHeader={setErrorHeader}
                        />
                      )}
                    </Fragment>
                  ))}
                </tbody>
              </Table>
            </form>
          </Col>
        </Row>
      </div>
      <ErrorModal
        showError={showError}
        setShowError={setShowError}
        errorMessage={errorMessage}
        errorHeader={errorHeader}
      />
    </>
  );
};
export default Listdelete;

const ReadOnlyRows = ({
  ama,
  handleEditClick,
  setAmaId,
  increment,
  amotMedaCat,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת אמת מידה "${ama.id}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const deletePost = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "amotmeda/" + ama.id,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    deletePost();
    setAmaId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={ama.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{ama.id}</td>
        <td>
          <GetAmotMedaCat
            amotMedaCat={amotMedaCat}
            catIndex={ama.amot_meda_cat}
          />
        </td>
        <td>{ama.meshkal}</td>
        <td>{ama.tsion}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, ama)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("AmootMeda", ama.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
